import { render } from "./AboutSection.vue?vue&type=template&id=a31469a6&scoped=true"
import script from "./AboutSection.vue?vue&type=script&lang=js"
export * from "./AboutSection.vue?vue&type=script&lang=js"

import "./AboutSection.vue?vue&type=style&index=0&id=a31469a6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a31469a6"]])

export default __exports__